var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ckeditor',{ref:"editor",attrs:{"value":_vm.value,"config":_vm.editorConfig},on:{"input":(v) => _vm.$emit('input', v),"ready":_vm.onReady}})
}
var staticRenderFns = []

export { render, staticRenderFns }